var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tenantUsesAvailabilityChangelog && !_vm.isOwner)?_c('v-btn',{staticClass:"ma-2",attrs:{"icon":"","disabled":_vm.loading},on:{"click":function($event){return _vm.toggleAvailabilityTimelineOpenOnClick(
        !_vm.openAvailabilityTimelineOnClick
      )}}},[_c('v-icon',{class:{
        'changelog-active': _vm.openAvailabilityTimelineOnClick,
      }},[_vm._v("fal fa-history")])],1):_vm._e(),_c('v-btn',{staticClass:"ma-2",attrs:{"icon":"","disabled":_vm.loading},on:{"click":_vm.open}},[_c('v-icon',[_vm._v("fal fa-ellipsis-v")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }